import { createFileRoute } from '@tanstack/react-router';
import ControlTestResultPage from '@/pages/compliance/automation/test-result';

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/automation/$executionId/'
)({
  component: ControlTestResultPage,
});
